
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { NursingHome } from "@/hooks/use-nursing-home";
import { BasicInfoForm } from "./BasicInfoForm";
import { FacilitiesForm } from "./FacilitiesForm";
import { RoomsForm } from "./RoomsForm";

interface ProfileTabsProps {
  nursingHome: NursingHome;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onSave: (data: Partial<NursingHome>) => Promise<NursingHome>;
  isSaving: boolean;
}

export function ProfileTabs({ 
  nursingHome, 
  activeTab, 
  setActiveTab,
  onSave,
  isSaving
}: ProfileTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
      <TabsList className="grid grid-cols-3 w-full max-w-md">
        <TabsTrigger value="basic">Basic Info</TabsTrigger>
        <TabsTrigger value="facilities">Facilities</TabsTrigger>
        <TabsTrigger value="rooms">Rooms & Pricing</TabsTrigger>
      </TabsList>
      
      <TabsContent value="basic" className="space-y-4">
        <BasicInfoForm
          nursingHome={nursingHome}
          onSave={onSave}
          isSaving={isSaving}
        />
      </TabsContent>
      
      <TabsContent value="facilities" className="space-y-4">
        <FacilitiesForm
          nursingHome={nursingHome}
          onSave={onSave}
          isSaving={isSaving}
        />
      </TabsContent>
      
      <TabsContent value="rooms" className="space-y-4">
        <RoomsForm
          nursingHome={nursingHome}
          onSave={onSave}
          isSaving={isSaving}
        />
      </TabsContent>
    </Tabs>
  );
}
